function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { usePresetTransition } from "./usePresetTransitions";
import { useMemo } from "react";
import { useThemeEasing } from "./useThemeEasing";
export var useStyles = function(param) {
    var transitions = param.transitions, duration = param.duration, easing = param.easing, shouldEnter = param.enter, shouldExit = param.exit;
    var selectedTransition = usePresetTransition(transitions);
    var selectedEasing = useThemeEasing(easing);
    return useMemo(function() {
        if (typeof selectedTransition === 'undefined') {
            return {
                appear: {},
                appearing: {},
                appeared: {},
                enter: {},
                entering: {},
                entered: {},
                exit: {},
                exiting: {},
                exited: {}
            };
        }
        var _appear, ref, _enter, _exit;
        var calculatedDurations = typeof duration === 'number' ? {
            appear: duration,
            enter: duration,
            exit: duration
        } : {
            appear: (ref = (_appear = duration.appear) !== null && _appear !== void 0 ? _appear : duration.enter) !== null && ref !== void 0 ? ref : 0,
            enter: (_enter = duration.enter) !== null && _enter !== void 0 ? _enter : 0,
            exit: (_exit = duration.exit) !== null && _exit !== void 0 ? _exit : 0
        };
        var durationStyles = {
            appear: {
                transitionDuration: shouldEnter ? "".concat(calculatedDurations.appear, "ms") : ''
            },
            enter: {
                transitionDuration: shouldEnter ? "".concat(calculatedDurations.enter, "ms") : ''
            },
            exit: {
                transitionDuration: shouldExit ? "".concat(calculatedDurations.exit, "ms") : ''
            }
        };
        var common = _objectSpread({}, selectedTransition === null || selectedTransition === void 0 ? void 0 : selectedTransition.common, {
            transitionProperty: selectedTransition.transitionProperty,
            transitionTimingFunction: selectedEasing
        });
        var inStyles = _objectSpread({}, common, durationStyles.enter, selectedTransition.in);
        var outStyles = _objectSpread({}, common, durationStyles.exit, selectedTransition.out);
        var appear = _objectSpread({}, outStyles, durationStyles.appear, selectedTransition.enter, selectedTransition.appear);
        var enter = _objectSpread({}, outStyles, selectedTransition.enter);
        var exit = _objectSpread({}, inStyles, selectedTransition.exit);
        var appearing = _objectSpread({}, inStyles, durationStyles.appear, selectedTransition.entering, selectedTransition.appearing);
        var entering = _objectSpread({}, inStyles, selectedTransition.entering);
        var exiting = _objectSpread({}, outStyles, selectedTransition.exiting);
        var appeared = _objectSpread({}, inStyles, durationStyles.appear, selectedTransition.entered, selectedTransition.appeared);
        var entered = _objectSpread({}, inStyles, selectedTransition.entered);
        var exited = _objectSpread({}, outStyles, selectedTransition.exited);
        return {
            appear: appear,
            appearing: appearing,
            appeared: appeared,
            enter: enter,
            entering: entering,
            entered: entered,
            exit: exit,
            exiting: exiting,
            exited: exited
        };
    }, [
        selectedTransition,
        duration,
        selectedEasing,
        shouldEnter,
        shouldExit
    ]);
};
